var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('v-row',[_c('v-col',{staticClass:"text-h6 red-text",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.networkError || _vm.status)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }